/**
 * Convert the semantic version to a comparable number.
 * Formula: major * 1M + minor * 1K + patch
 *
 * @param version - Version string (e.g., "2.1.5")
 * @returns Numeric version, or 0 if invalid/empty/oversized (>999 per part)
 *
 * @example
 * ```typescript
 * versionToNumber("2.1.5")    // 2001005
 * versionToNumber("2.1")      // 2001000
 * versionToNumber("10.25.3")  // 10025003
 * versionToNumber("")         // 0
 * versionToNumber("1000.0.0") // 0
 * ```
 */
export function versionToNumber(version: string): number {
  if (!version) return 0;

  const parts = version.split('.').map((p) => parseInt(p, 10) || 0);
  const major = parts[0] || 0;
  const minor = parts[1] || 0;
  const patch = parts[2] || 0;

  // Each part should be 0-999 to prevent overflow
  if (major > 999 || minor > 999 || patch > 999) {
    return 0;
  }

  return major * 1000000 + minor * 1000 + patch;
}
